import React, { useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import List from '../../../../commonComponents/lists/List';
import UserColumn from '../../../../commonComponents/lists/columns/UserColumn';
import ProgressColumn from './ProgressColumn';
import {
  formatNumbers,
  newFormatPrice,
} from '../../../../services/utilityFunctions';
import Checkbox from '../../../../commonComponents/forms/inputs/Checkbox';
import FormGroup from '../../../../commonComponents/forms/FormGroup';

// Gets and the unity type
const getUnity = (unity, t) => {
  let infoUnity = '';
  if (unity === 'points') {
    infoUnity = 'pts';
  } else if (unity === 'percentage') {
    infoUnity = '%';
  } else if (unity === 'VA') {
    infoUnity = t('challengeDetails_leaderboard_VA');
  }
  return infoUnity;
};

function LeaderboardList({ t, challengeId, scoreTarget, unity }) {
  const tableId = 'leaderboardId';
  const getTopStyle = topType => {
    let topText = '';
    let topClass = '';
    if (topType === 'top5') {
      topText = t('challengeDetails.leaderboard.top5_player');
      topClass = 'top5';
    }
    if (topType === 'median') {
      topText = t('challengeDetails.leaderboard.median_player');
      topClass = 'median';
    }
    if (topType === 'worst5') {
      topText = t('challengeDetails.leaderboard.worst5_player');
      topClass = 'worst5';
    }
    return { topClass, topText };
  };
  const renderTopType = (topType, isMe, index) => {
    const topStyle = getTopStyle(topType);
    if (isMe) {
      // Responsible to check if it's the user and add the highlight class
      $(`#${tableId} tr[data-row=${index}]`).addClass('highlight');
    }
    let text = topStyle.topText;
    const checked = $('#showAllUsers').is(':checked');

    if (checked) {
      text = '';
    }
    return renderToStaticMarkup(
      <div className="leaderboard-top-column">
        <h6 className={topStyle.topClass}>{text}</h6>
      </div>,
    );
  };
  const renderPointsColumn = item => {
    const infoUnity = getUnity(item.unity, t);
    const score =
      item.unity === 'currency'
        ? newFormatPrice(item.points, false, item.currency || 'eur')
        : `${formatNumbers(item.points)} ${infoUnity}`;
    return renderToStaticMarkup(
      <div className="leaderboard-top-column no-wrap-value">{score}</div>,
    );
  };
  const columns = [
    {
      field: 'position',
      title: t('challengeDetails_leaderboard_position'),
      textAlign: 'center',
      width: 100,
    },
    {
      field: 'owner',
      title: t('user'),
      sortable: false,
      template: item =>
        renderToStaticMarkup(
          <UserColumn t={t} user={item.owner} showUserName />,
        ),
    },
    {
      field: 'workplace',
      title: t('profile_workplace'),
      textAlign: 'center',
      width: 100,
      template: ({ owner }) =>
        renderToStaticMarkup(<>{owner?.workplace || '-'}</>),
    },
    {
      field: 'top',
      title: '',
      textAlign: 'center',
      width: 100,
      template: ({ topType, isMe }, index) =>
        renderTopType(topType, isMe, index),
    },
    {
      field: 'points',
      title: t(`challengeDetails_leaderboard_${unity}`),
      textAlign: 'center',
      width: 100,
      template: item => renderPointsColumn(item),
    },
    {
      field: 'progress',
      title: t('challengeDetails_leaderboard_progress'),
      sortable: false,
      textAlign: 'center',
      template: row =>
        renderToStaticMarkup(
          <ProgressColumn points={row.points} scoreTarget={scoreTarget} />,
        ),
      width: 200,
    },
  ];

  const dataTransform = leader => ({
    ...leader,
    position: leader.position !== -1 ? leader.position : '-',
  });
  const [showAllUsersCheckbox, setAllUsersCheckbox] = useState(false);
  const handleCheckbox = value => {
    setAllUsersCheckbox(value);
  };

  return (
    <>
      <div>
        <FormGroup className="row checkbox-container">
          <Checkbox
            id="showAllUsers"
            name="showAllUsers"
            label="Show all Users"
            value={showAllUsersCheckbox}
            onChange={({ currentTarget }) => {
              handleCheckbox(currentTarget.checked);
            }}
            className="offset-2"
          />
        </FormGroup>
      </div>
      <List
        dataSourceURL={`/table/game/${challengeId}/leaderboard`}
        dataSourceHeaders={{
          'Accept-Version': '2.0.0',
          'X-Gamification-API': 'Games',
        }}
        dataTransform={dataTransform}
        columns={columns}
        id={tableId}
        dataSourceParams={{ populate: 'owner' }}
        query={{ showAllUsers: showAllUsersCheckbox }}
      />
    </>
  );
}

LeaderboardList.propTypes = {
  t: PropTypes.func.isRequired,
  challengeId: PropTypes.string.isRequired,
  scoreTarget: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  unity: PropTypes.string.isRequired,
};

export default translate(LeaderboardList);
